export default "__VITE_ASSET__aa963930__"